import { WorkFunction } from '../../work-function/work-function.model';
import {Pagination} from '../pagination.model';

export class WorkFunctionPage extends Pagination {
  content: WorkFunction[] = [];
}
